var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.831,
    height: 12.223,
    viewBox: "0 0 13.831 12.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M19.25,2.982V5.556a.482.482,0,1,0,.965,0V2.982a.482.482,0,1,0-.965,0Z",
    transform: "translate(-6.42)",
    fill: "#292828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M17.732,5.465h2.573a.482.482,0,0,0,0-.965H17.732a.482.482,0,1,0,0,.965Z",
    transform: "translate(-5.707 -0.713)",
    fill: "#292828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M9.452,3H6.312A1.126,1.126,0,0,0,5.3,3.622L4.7,4.841a.162.162,0,0,1-.144.089H3.019A1.769,1.769,0,0,0,1.25,6.7v6.433A1.768,1.768,0,0,0,3.019,14.9H13.312a1.768,1.768,0,0,0,1.769-1.769V7.664a.482.482,0,1,0-.965,0v5.468a.8.8,0,0,1-.8.8H3.019a.8.8,0,0,1-.8-.8V6.7a.8.8,0,0,1,.8-.8H4.552a1.126,1.126,0,0,0,1.007-.622l.609-1.219a.162.162,0,0,1,.144-.089H9.452a.482.482,0,1,0,0-.965Z",
    transform: "translate(0 -0.178)",
    fill: "#292828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M10.306,8.5a3.056,3.056,0,1,0,3.056,3.056A3.057,3.057,0,0,0,10.306,8.5Zm0,.965a2.091,2.091,0,1,1-2.091,2.091A2.092,2.092,0,0,1,10.306,9.465Z",
    transform: "translate(-2.14 -2.14)",
    fill: "#292828",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.2a79a4c818ddef458cbb48b36736ab05.svg";
export { ForwardRef as ReactComponent };